import axios from 'axios';
import { checkToken } from '../utils/localStore';
import { refreshToken } from './api/loginService';
// import { notiWarning } from '../utils/notification';
// import { refreshToken } from './api/loginService';

const getStoreLocal = (item) => {
    if (typeof window !== 'undefined') {
        return localStorage.getItem(item);
    }
};

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        accept: 'application/json',
        'User-Agent': `Payment-BO ${process.env.HOST_NAME_USER ?? 'oke'}`,
    },
});

const urlCheck = [
    '/authen/verify',
    '/authen/refresh-token',
    '/authen/logout',
    '/authen/login-link',
];

const onRequest = async (config) => {
    const token = getStoreLocal('access_token');

    config.headers = {
        Authorization: ` Bearer ${token}`,
    };

    if (urlCheck.includes(config.url)) return config;

    const status = checkToken();

    if (status === 'TOKEN_VALID') return config;

    if (status === 'EXPIRED_ACCESS_TOKEN') {
        const refresh = getStoreLocal('refresh-token');
        await refreshToken(refresh, process.env.HOST_NAME_REDIRECT);
        return config;
    }

    // if (status === 'EXPIRED_REFRESH_TOKEN') {
    //     // notiWarning('Đăng nhập lại ứng dụng !!!');
    //     return Promise.reject('Phiên đăng nhập hết hạn');
    // }

    return Promise.reject('Phiên đăng nhập hết hạn');
};

const onError = (error) => {
    return Promise.reject(error);
};

axiosClient.interceptors.request.use(onRequest, onError);

axiosClient.interceptors.response.use(
    (response) => {
        if (response.data) {
            return response.data;
        }
        return response;
    },
    (error) => {
        throw error;
    }
);

export default axiosClient;
